(() => {
  if (window.TechReviveNativeCart) return;

  const normalize = (value) => String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim();

  const compactProperties = (properties) => Object.fromEntries(
    Object.entries(properties || {}).filter(([, value]) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && String(value).trim() !== '';
    }).map(([key, value]) => [key, Array.isArray(value) ? value.join(', ') : String(value).trim()])
  );

  const configuredVariant = (variants, title) => {
    const wanted = normalize(title);
    return (variants || []).find((variant) => normalize(variant.title) === wanted) || null;
  };

  const configurationId = () => {
    const randomPart = window.crypto?.randomUUID?.().slice(0, 8) || Math.random().toString(36).slice(2, 10);
    return `TR-${Date.now().toString(36)}-${randomPart}`.toUpperCase();
  };

  const cartUrl = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${path}`.replace(/\/\/{2,}/g, '/');
  };

  async function responseJson(response) {
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) {
      const message = data.description || data.message || 'The configured service could not be added to the cart.';
      throw new Error(message);
    }
    return data;
  }

  async function addConfiguration({
    root,
    productId,
    parentVariantId,
    parentProperties,
    addOns = [],
    addonVariants = [],
    serviceLabel = 'Configured service'
  }) {
    const parentId = Number(parentVariantId);
    if (!Number.isFinite(parentId) || parentId <= 0) {
      throw new Error('The selected service tier is unavailable. Refresh the page and try again.');
    }

    const id = configurationId();
    const parent = {
      id: parentId,
      quantity: 1,
      properties: compactProperties({
        ...parentProperties,
        '_TechRevive configuration ID': id
      })
    };

    const children = addOns.map((addOn) => {
      const variant = configuredVariant(addonVariants, addOn.variantTitle);
      if (!variant) {
        throw new Error(`The ${addOn.label || addOn.variantTitle} price item is not connected yet.`);
      }
      if (variant.available === false) {
        throw new Error(`${addOn.label || addOn.variantTitle} is temporarily unavailable.`);
      }

      return {
        id: Number(variant.id),
        quantity: Number(addOn.quantity) || 1,
        parent_id: parentId,
        properties: compactProperties({
          '_TechRevive configuration ID': id,
          '_Configured for': serviceLabel,
          ...(addOn.properties || {})
        })
      };
    });

    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);

    const response = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [parent, ...children],
        sections: [...new Set(sectionIds)].join(',')
      })
    });
    const added = await responseJson(response);

    const cartResponse = await fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' }
    });
    const cart = await responseJson(cartResponse);

    (root || document).dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: root?.id || String(parentId),
        data: {
          source: 'product-form-component',
          itemCount: 1 + children.length,
          productId: String(productId || ''),
          variantId: String(parentId),
          sections: added.sections || {}
        }
      }
    }));

    return { added, cart };
  }

  window.TechReviveNativeCart = { addConfiguration };
})();
